import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "configureStore";
import { Button, InlineStack, Banner } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { setDestroy, setIsModalxOpen } from "components/modalx/modalx.slice";
import { useParams } from "react-router-dom";
import { fetchCabinetSummaryThunk } from "features/cabinet-tasks/cabinet-summary.slice";
import { updateStatus } from "services/reviewfiles.service";
import { fetchFileDetails } from "containers/file/file.Slice";
import { fetchAuthorizedFileDetails } from "containers/file-authorized/authorized-file.Slice";

interface ConfirmModalProps {
  id: string;
  fileId?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ id, fileId }) => {
  const dispatch: AppDispatch = useDispatch();
  const { t } = useTranslation();
  const { companyId } = useParams();

  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errMsg, setErrMsg] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleToSendRequest = async () => {
    try {
      setIsLoading(true);
      await updateStatus(id, {});
      // The bell and the menu ask the summary again.
      if (id && companyId) dispatch(fetchCabinetSummaryThunk(companyId));
      if (companyId && fileId) {
        dispatch(fetchFileDetails({ fileId, companyId }));
        dispatch(fetchAuthorizedFileDetails({ fileId, companyId }));
      }
      setSuccessMessage("ok");
      setIsLoading(false);
      closeModal();
    } catch (e) {
      setErrMsg("error");
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    dispatch(setIsModalxOpen(false));
    dispatch(setDestroy());
  };

  return (
    <>
      <div className="form-warnings">
        {errMsg && (
          <div>
            <Banner tone="critical">{t(errMsg)}</Banner>
          </div>
        )}
        {successMessage && (
          <div>
            <Banner tone="info">{t(successMessage)}</Banner>
          </div>
        )}
      </div>
      <h1 style={{ textAlign: "center" }}>
        {t("are_you_sure_you_want_mark_as_reviewed")}
      </h1>

      <InlineStack align="space-between">
        <Button onClick={handleToSendRequest} loading={isLoading}>
          {t("Yes")}
        </Button>

        <Button onClick={closeModal}>{t("No")}</Button>
      </InlineStack>
    </>
  );
};

export default ConfirmModal;
